// breakwater-fe/src/actions/AgentEscalationActions.js
import {
  listAgentEscalations,
  getAgentEscalation as backendGetAgentEscalation,
  resolveAgentEscalation as backendResolveAgentEscalation,
  dismissAgentEscalation as backendDismissAgentEscalation,
} from '../Backend';

export const LOAD_AGENT_ESCALATIONS         = 'LOAD_AGENT_ESCALATIONS';
export const LOAD_AGENT_ESCALATIONS_SUCCESS = 'LOAD_AGENT_ESCALATIONS_SUCCESS';
export const LOAD_AGENT_ESCALATIONS_FAIL    = 'LOAD_AGENT_ESCALATIONS_FAIL';

export const LOAD_AGENT_ESCALATION          = 'LOAD_AGENT_ESCALATION';
export const LOAD_AGENT_ESCALATION_SUCCESS  = 'LOAD_AGENT_ESCALATION_SUCCESS';
export const LOAD_AGENT_ESCALATION_FAIL     = 'LOAD_AGENT_ESCALATION_FAIL';

export const RESOLVE_AGENT_ESCALATION       = 'RESOLVE_AGENT_ESCALATION';
export const RESOLVE_AGENT_ESCALATION_SUCCESS = 'RESOLVE_AGENT_ESCALATION_SUCCESS';
export const RESOLVE_AGENT_ESCALATION_FAIL  = 'RESOLVE_AGENT_ESCALATION_FAIL';

export const DISMISS_AGENT_ESCALATION       = 'DISMISS_AGENT_ESCALATION';
export const DISMISS_AGENT_ESCALATION_SUCCESS = 'DISMISS_AGENT_ESCALATION_SUCCESS';
export const DISMISS_AGENT_ESCALATION_FAIL  = 'DISMISS_AGENT_ESCALATION_FAIL';

export const SELECT_AGENT_ESCALATION        = 'SELECT_AGENT_ESCALATION';

export const selectAgentEscalation = (escalation) => ({ type: SELECT_AGENT_ESCALATION, escalation });

export const fetchAgentEscalations = (filters = {}) => async (dispatch) => {
  dispatch({ type: LOAD_AGENT_ESCALATIONS, filters });
  try {
    const res = await listAgentEscalations(filters);
    const json = await res.json();
    if (!res.ok) throw new Error(json.error || 'failed');
    dispatch({
      type: LOAD_AGENT_ESCALATIONS_SUCCESS,
      filters,
      escalations: json.escalations || [],
      counts: json.counts || {},
    });
  } catch (e) {
    dispatch({ type: LOAD_AGENT_ESCALATIONS_FAIL, filters, error: e.message });
  }
};

export const fetchAgentEscalation = (escalationId) => async (dispatch) => {
  dispatch({ type: LOAD_AGENT_ESCALATION, escalationId });
  try {
    const res = await backendGetAgentEscalation(escalationId);
    const json = await res.json();
    if (!res.ok) throw new Error(json.error || 'failed');
    dispatch({ type: LOAD_AGENT_ESCALATION_SUCCESS, escalation: json });
    return json;
  } catch (e) {
    dispatch({ type: LOAD_AGENT_ESCALATION_FAIL, escalationId, error: e.message });
    return null;
  }
};

export const resolveAgentEscalation = (escalationId, resolution_action, notes = '') => async (dispatch) => {
  dispatch({ type: RESOLVE_AGENT_ESCALATION, escalationId });
  try {
    const res = await backendResolveAgentEscalation(escalationId, resolution_action, notes);
    const json = await res.json();
    if (!res.ok) throw new Error(json.error || 'failed');
    dispatch({ type: RESOLVE_AGENT_ESCALATION_SUCCESS, escalation: json });
    return true;
  } catch (e) {
    dispatch({ type: RESOLVE_AGENT_ESCALATION_FAIL, escalationId, error: e.message });
    return false;
  }
};

export const dismissAgentEscalation = (escalationId, notes = '') => async (dispatch) => {
  dispatch({ type: DISMISS_AGENT_ESCALATION, escalationId });
  try {
    const res = await backendDismissAgentEscalation(escalationId, notes);
    const json = await res.json();
    if (!res.ok) throw new Error(json.error || 'failed');
    dispatch({ type: DISMISS_AGENT_ESCALATION_SUCCESS, escalation: json });
    return true;
  } catch (e) {
    dispatch({ type: DISMISS_AGENT_ESCALATION_FAIL, escalationId, error: e.message });
    return false;
  }
};
